import { LayoutBand, Separator } from '@fs/zion-ui'
import React from 'react'
import ContributionsHeaderSkeleton from '../ContributionsComponents/ContributionsHeader/ContributionsHeaderSkeleton'
import ContributionsActionBarSkeleton from '../ContributionsComponents/ContributionsActionBar/ContributionsActionBarSkeleton'
import ChangeLogGeneralViewSkeleton from '../ChangeLogGeneralView/ChangeLogGeneralViewSkeleton'

export default function ChangeLogChangesPageSkeleton(): JSX.Element {
  return (
    <>
      <ContributionsHeaderSkeleton />

      <LayoutBand maxWidth="xxl">
        <Separator size="xxs" />
        <ContributionsActionBarSkeleton />
        <ChangeLogGeneralViewSkeleton />
      </LayoutBand>
      <Separator />
    </>
  )
}
